
import backEnd from "../apis/backEnd";
import coldSmtpApi from "../apis/coldSmtpApi";
import smtpBackend from "../apis/smtpBackend";
import { type } from '../actions/type';
import history from "../history";




//UserLogin Action
export const logIn = (tokenId) => async (dispatch) => {
  try {
    const response = await backEnd.post("/login", { tokenId });

    if (response.status === 201) {
      dispatch({
        type: type.LOGIN, payload: {
          tokenId, email: response.data.email, name: response.data.name, expiry: Date.now() + (60000 * 60 * 24)

        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else {

      console.log("Backend Server is not reachable");
    }
    return "failed";
  }
};

//UserLogout Action
export const logOut = () => async (dispatch) => {

  dispatch({ type: type.LOGOUT })

  history.push('/login')
};


//Campaign Search Action

export const campaignSearch = (searchTerm) => async (dispatch) => {

  try {
    const response = await backEnd.post("/campaignSearch", { searchTerm });

    if (response.status === 201) {
      dispatch({
        type: type.CAMPAIGN_RESULT, payload: {
          userData: response.data.userData, campaignData: response.data.campaignData
        }
      })
      dispatch({
        type: type.CAMPAIGN_SEARCH, payload: {
          campaignSearch: searchTerm
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }
}


//Header Menu Selection Action

export const switchHomeSection = (selectedOption) => async (dispatch) => {

  dispatch({
    type: type.SWITCH_HOME_SECTION, payload: {
      selectedMenu: selectedOption
    }
  })
}

//SELECT LOG TYPE

export const selectLogType = (logType) => async (dispatch) => {

  dispatch({
    type: type.SELECT_LOG_TYPE, payload: {
      selectedLogType: logType
    }
  })

}

// Comp Account
export const compAccount = (email) => async (dispatch) => {

  try {
    const response = await backEnd.post("/compAccount", { email });

    if (response.status === 201) {
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

//Cancel Subscription

export const cancelSubscription = (email) => async (dispatch) => {

  try {
    const response = await backEnd.post("/cancelSubscription", { email });

    if (response.status === 201) {
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

//Get API LOGS

export const getApiLogs = (email, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/apiLogs", { email, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.API_LOGS, payload: {
          apiLogs: response.data.result,
          searchTerm: email
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}
//Get Extension LOGS

export const getExtensionLogs = (email, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/extensionLogs", { email, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.EXTENSION_LOGS, payload: {
          extensionLogs: response.data.result,
          searchTerm: email
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

//Get SMTP Push Logs

export const getSmtpPushLogs = (email, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/smtpPushLogs", { email, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.SMTP_PUSH_LOGS, payload: {
          smtpPushLogs: response.data.result,
          searchTerm: email
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}


export const getOutboundLogs = (searchTerm, date, logsLimit, recipientEmail) => async (dispatch) => {

  try {
    const response = await backEnd.post("/outboundLogs", { searchTerm, date, logsLimit, recipientEmail });

    if (response.status === 200) {
      dispatch({
        type: type.OUTBOUND_LOGS, payload: {
          outboundLogs: response.data.result,
          searchTerm: searchTerm

        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

export const getDraftEditLogs = (campaignId, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/draftEditLogs", { campaignId, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.DRAFTEDIT_LOGS, payload: {
          draftEditLogs: response.data.result,
          searchTerm: campaignId,
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

export const getProcessingLogs = (campaignId, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/processingLogs", { campaignId, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.PROCESSING_LOGS, payload: {
          processingLogs: response.data.result,
          searchTerm: campaignId
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}


export const getSheetLogs = (email, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/sheetLogs", { email, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.SHEET_LOGS, payload: {
          sheetLogs: response.data.result,
          searchTerm: email
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

export const getWarmupLogs = (email, date, logsLimit, outgoing, incoming, notArchived) => async (dispatch) => {

  try {
    const response = await backEnd.post("/warmupLogs", { email, date, logsLimit, outgoing, incoming, notArchived });

    if (response.status === 200) {
      dispatch({
        type: type.WARMUP_LOGS, payload: {
          warmupLogs: response.data.result,
          searchTerm: email
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}


export const getSMTPLogs = (email, date, logsLimit, delivered, bounced) => async (dispatch) => {

  try {
    const response = await smtpBackend.post("/smtpLogs", { email, date, logsLimit, delivered, bounced });

    if (response.status === 200) {
      dispatch({
        type: type.SMTP_LOGS, payload: {
          smtpLogs: response.data.result,
          searchTerm: email
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}


export const getCampaignErrorLogs = (campaignId, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/campaignErrorLogs", { campaignId, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.CAMPAIGN_ERROR_LOGS, payload: {
          campaignErrorLogs: response.data.result,
          searchTerm: campaignId
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}



export const getStatusLogs = (campaignId, date, logsLimit) => async (dispatch) => {

  try {
    const response = await backEnd.post("/statusLogs", { campaignId, date, logsLimit });

    if (response.status === 200) {
      dispatch({
        type: type.STATUS_LOGS, payload: {
          statusLogs: response.data.result,
          searchTerm: campaignId
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    } else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }

}

/* COLD SMTP Actions */

//GET Domain Information

export const getColdSMTPDomains = () => async (dispatch) => {
  try {
    // Make both API calls in parallel using Promise.all
    const [domainsResponse, distributionResponse] = await Promise.all([
      coldSmtpApi.get("/get-all-domains"),
      coldSmtpApi.get("/get-domain-distribution")
    ]);

    if (domainsResponse.status === 200 && distributionResponse.status === 200) {
      dispatch({
        type: type.COLD_SMTP_DOMAIN_RESULT,
        payload: {
          domainData: domainsResponse.data.result,
          domainDistribution: distributionResponse.data.result
        }
      });
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed");
      return "failed";
    } else {
      console.error(error.response);
    }
    return "failed";
  }
};


export const changeDomainStatus = (domain_name, status) => async (dispatch) => {

  //Resetting dData to null so that Loader comes up while changing Status

  dispatch({
    type: type.COLD_SMTP_RESET_DOMAIN_RESULT
  })
  try {
    let response;

    if(!status){ //Deactivate domain
      response = await coldSmtpApi.post("/remove-domain", { domain_name});
    }else{
      //Activate the domain
      response = await coldSmtpApi.post("/add-domain", { domain_name});
    }
    

    if (response.status === 200) {
      dispatch({
        type: type.COLD_SMTP_DOMAIN_RESULT, payload: {
          domainData: response.data.result
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else {
      console.log(error.response);
    }
    return "failed";
  }

}

// Cold SMTP Search for Domain--> Returns list of all users using the current domain, User--> returns information about user using the Cold SMTP user

export const coldSMTPSearch = (searchTerm) => async (dispatch) => {

  let response;  

  try {

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    const domainRegex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    if(domainRegex.test(searchTerm)){
      response = await coldSmtpApi.post("/domainSearch", { searchTerm });  
    }

    if(emailRegex.test(searchTerm)){
      response = await coldSmtpApi.post("/userSearch", { searchTerm });  
    }

    if (response.status === 200) {

      if(emailRegex.test(searchTerm)){
        dispatch({
          type: type.COLD_SMTP_USER_RESULT, payload: {
            userData: response.data.user, dSearchData: null
          }
        })
      }else{
        dispatch({
          type: type.COLD_SMTP_DOMAINSEARCH_RESULT, payload: {
            userData: null, dSearchData: response.data.users
          }
        })
      }
      
      dispatch({
        type: type.COLD_SMTP_SEARCH_TERM, payload: {
          search: searchTerm
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, login failed")
      return "failed"
    } else if (error.response && error.response.status === 400) {
      console.log("Database didn't respond")
      return "failed"
    }else if(error.response && error.response.status===404){
      //Resetting the User and DOmain Search Data

      dispatch({
        type: type.COLD_SMTP_DOMAINSEARCH_RESULT, payload: {
          userData: null, dSearchData: null
        }
      })

      //We are returning success, as the call was success just that the resource was not FOUND
      return "success"
    } 
    else {
      console.log("Backend Server is not reachable");
    }
    return "failed";
  }
}

export const setOverrideDomain = (email, domain_name) => async (dispatch) => {
  try {
    let response;

    if (domain_name === null) {
      // Clear override domain using DELETE /remove-override
      response = await coldSmtpApi.delete("/remove-override", {
        params: { email } // Query parameter for DELETE
      });
    } else {
      // Set override domain using POST /override-domain
      response = await coldSmtpApi.post("/override-domain", { 
        email, 
        domain_name 
      });
    }

    if (response.status === 200) {
      // Dispatch action to update Redux state (optional)
      dispatch({
        type: type.COLD_SMTP_USER_RESULT, payload: {
          userData: response.data.user, dSearchData: null
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        console.log("Bad request:", error.response.data.error || "Invalid input");
        return "failed";
      } else if (error.response.status === 401) {
        console.log("Unauthorized access, failed to set/remove override domain");
        return "failed";
      } else if (error.response.status === 404) {
        console.log(error.response.data.error || "Resource not found");
        return "failed";
      } else if (error.response.status === 500) {
        console.log("Server error:", error.response.data.error);
        return "failed";
      } else {
        console.log("Unexpected error from backend:", error.response.status);
        return "failed";
      }
    } else {
      console.log("Backend server is not reachable");
      return "failed";
    }
  }
};


//Set Own Domain for Cold SMTP USer

export const setOwnDomain = (email, useOwnDomain) => async (dispatch) => {
  try {
    const response = await coldSmtpApi.post("/set-own-domain", { 
      email, 
      useOwnDomain 
    });

    if (response.status === 200) {
      dispatch({
        type: type.COLD_SMTP_USER_RESULT, payload: {
          userData: response.data.user, dSearchData: null
        }
      })
      return "success";
    }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        console.log("Bad request:", error.response.data.error || "Invalid input");
        return "failed";
      } else if (error.response.status === 401) {
        console.log("Unauthorized access, failed to set use own domain");
        return "failed";
      } else if (error.response.status === 404) {
        console.log("User not found"); // Backend throws 500 for this, but could be adjusted
        return "failed";
      } else if (error.response.status === 500) {
        console.log("Server error:", error.response.data.error);
        return "failed";
      } else {
        console.log("Unexpected error from backend:", error.response.status);
        return "failed";
      }
    } else {
      console.log("Backend server is not reachable");
      return "failed";
    }
  }
};